import React from 'react';
import PropTypes from 'prop-types';

import Alert from '../Alert';
import {
  DISCOUNT_TEMPLATE_PRODUCTS,
  DISCOUNT_TEMPLATE_TYPE,
} from '../../../constants/discount-templates';
import { CURRENCY } from '../../../constants/currency';
import { DATE_OFFSET_TYPE } from '../../../constants/dates';
import { getDiscountBannerText } from './helpers';

const dateOffsetShape = PropTypes.shape({
  offset: PropTypes.number,
  offset_type: PropTypes.oneOf(Object.values(DATE_OFFSET_TYPE)),
});

const propTypes = {
  discountTemplate: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(DISCOUNT_TEMPLATE_TYPE)),
    discount_value: PropTypes.number,
    products: PropTypes.arrayOf(
      PropTypes.oneOf(Object.values(DISCOUNT_TEMPLATE_PRODUCTS)),
    ),
    min_checkout_amount: PropTypes.shape({
      value: PropTypes.number,
      currency: PropTypes.oneOf(Object.values(CURRENCY)),
    }),
    start_date_offset: dateOffsetShape,
    end_date_offset: dateOffsetShape,
  }),
  eventStartDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  firstPhotoPublishedAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  className: PropTypes.string,
};

const DiscountBanner = ({
  discountTemplate,
  eventStartDate,
  firstPhotoPublishedAt,
  className,
}) => {
  const text = getDiscountBannerText(discountTemplate, {
    eventStartDate,
    firstPhotoPublishedAt,
  });

  if (!text) {
    return null;
  }

  return (
    <Alert type="info" className={className} borderless>
      {text}
    </Alert>
  );
};

DiscountBanner.propTypes = propTypes;

export default DiscountBanner;
